<template>
  <v-form ref="formQuestion" style="width: 100%">
    <v-card style="width: 100%">
      <v-card-title class="justify-center align-center">
        <span>{{ this.question[$t('question.label')] }}</span>
      </v-card-title>
      <v-card-text class="body-1">
        <v-text-field
          v-model="response"
          filled
          dense
          :rules="[obligatoireRule(), serveurRule('response')]"
          :label="$t('question.changeDialog.response')"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="$emit('emitQuestion')">
          {{ $t('button.confirm') }}
        </v-btn>
        <v-btn
          text
          :to="{
            name: 'Login',
            params: { namespaceonly: true },
          }"
        >
          {{ $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-alert dense border="left" type="warning">
          {{ $t('question.contact') }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import ValidationRules from '@/plugins/mixins/ValidationRules'

export default {
  mixins: [ValidationRules],
  provide() {
    return {
      $vroot: this.$v,
    }
  },
  props: {
    serveurRule: {
      type: Function,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      response: null,
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {
    response(val) {
      this.$emit('emitResponse', val)
    },
  },
  methods: {
    validerQuestion() {
      const ok = this.$refs.formQuestion.validate()
      return ok
    },

    getForms() {
      return [this.$refs.formQuestion]
    },
  },
  validations: {},
}
</script>
